import { Modal } from '@insify/design-system/components';

import { usePastClaims } from '../../usePastClaims';
import { ClaimsEditForm } from '../ClaimsEditForm';

import type { PastClaimsProps } from '../../PastClaims';

export const ClaimsEdit = <CoverageKey extends string>({
  country,
  translations,
  validation,
  onBack,
  richContent,
  currencyPosition,
  thousandSeparator,
}: PastClaimsProps<CoverageKey>) => {
  const [{ hasPastClaimFormEnabled }, { closePastClaimForm }] = usePastClaims();
  return (
    <Modal open={hasPastClaimFormEnabled} onClose={closePastClaimForm} trackingId='editClaim'>
      <ClaimsEditForm
        country={country}
        validation={validation}
        onBack={onBack}
        richContent={richContent}
        translations={translations}
        currencyPosition={currencyPosition}
        thousandSeparator={thousandSeparator}
      />
    </Modal>
  );
};
